import { connect } from 'react-redux'
import ConversationComponent from '../../components/Conversation';

const mapStateToProps = (state, props) => {
  if (!props.conversation || !props.conversation.id) {
    return {};
  }

  var message = state.advisory.outboundMessages[props.conversation.id] ? state.advisory.outboundMessages[props.conversation.id] : '';
  return {
    outboundMessage: message
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

// The container grants access to redux state from the message list component.
const Conversation = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConversationComponent)

export default Conversation



// WEBPACK FOOTER //
// ./src/components/ConversationOverview/containers/Conversation/index.js